import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onNewBooking }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4 px-4 md:px-6 lg:px-8 py-4 md:py-5 lg:py-6 bg-muted/30 border-y border-border">
      <Button
        variant="default"
        size="default"
        iconName="Plus"
        iconPosition="left"
        onClick={onNewBooking}
        className="flex-1 sm:flex-initial"
      >
        New Booking
      </Button>
      
      <Button
        variant="outline"
        size="default"
        iconName="Users"
        iconPosition="left"
        onClick={() => navigate('/customer-database')}
        className="flex-1 sm:flex-initial"
      >
        Customer Database
      </Button>
      
      <Button
        variant="outline"
        size="default"
        iconName="Clock"
        iconPosition="left"
        onClick={() => navigate('/booking-management')}
        className="flex-1 sm:flex-initial"
      >
        Manage Bookings
      </Button>
    </div>
  );
};

export default QuickActions;